import clsx from 'clsx';
import type { CSSProperties, ReactNode } from 'react';

import styles from './Toolbar.module.css';

type ToolbarProps = {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
};
export function Toolbar({ children, style, className }: ToolbarProps) {
  return (
    <div className={clsx(styles.space, className)} style={style}>
      {children}
    </div>
  );
}

type ToolbarItemProps = {
  toRight?: boolean;
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
};

export function ToolbarItem({ toRight: left = false, children, style, className }: ToolbarItemProps) {
  return (
    <div className={clsx(styles.spaceItem, className, left && styles.left)} style={style}>
      {children}
    </div>
  );
}

export function ToolbarSeparator() {
  return <div className={styles.spaceSeparator}></div>;
}
